import { render, staticRenderFns } from "./ActionAddflag.vue?vue&type=template&id=0ad6b3e6&scoped=true"
import script from "./ActionAddflag.vue?vue&type=script&lang=js"
export * from "./ActionAddflag.vue?vue&type=script&lang=js"
import style0 from "./ActionAddflag.vue?vue&type=style&index=0&id=0ad6b3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad6b3e6",
  null
  
)

export default component.exports